import maSpinner from '@/components/spinner'

export default {
  name: 'button-blue',
  props: {
    handleButtonClick: {
      type: Function
    },
    shouldBeDisabled: {
      type: Boolean,
      default: false
    },
    mainBlueShouldBeDisabled: {
      type: Boolean,
      default: false
    },
    mainWhiteShouldBeDisabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    helperMainBlueText: {
      type: String
    },
    total: {
      type: Number
    },
    btnType: {
      type: String
    },
    titleWhiteBtn: {
      type: String
    },
    helperMainWhiteText: {
      type: String
    },
    handleButtonClickWhiteBtn: {
      type: Function
    },
    classBtnExtra: {
      type: String
    }
  },
  components: {
    maSpinner
  }
}
